/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/no-unknown-property */
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Navigation, Scrollbar, Autoplay, Controller } from "swiper";
import { useDispatch, useSelector } from "../../redux/store";

import {
    getServiceBannerList
} from "../../redux/slices/common";

const HeroRSL = ({ type }) => {
    const dispatch = useDispatch();
    const [bannerImages, setBannerImages] = useState([]);

    const { serviceBannerList } = useSelector(
        (state) => state.common
    );

    useEffect(() => {
        dispatch(getServiceBannerList({ type: type }));
    }, []);

    useEffect(() => {
        if (serviceBannerList?.length > 0) {
            setBannerImages(serviceBannerList[0]?.backgroundImage);
        }
    }, [serviceBannerList]);

    return (
        <div className="masthead_rsl__bg mt-40">
            <Swiper
                spaceBetween={0}
                className="overflow-visible hero-custom"
                scrollbar={{ draggable: true }}
                autoplay={{ delay: 2500, disableOnInteraction: false }}
                pagination={{ clickable: true }}
                modules={[Controller, Autoplay, Scrollbar, Navigation]}
                navigation={{
                    nextEl: ".js-second-destination-next",
                    prevEl: ".js-second-destination-prev",
                }}
            >
                {bannerImages?.length > 0 ? (
                    bannerImages?.map((image, index) => (
                        <SwiperSlide key={index}>
                        <img
                            alt="banner"
                            src={`${process.env.IMAGE_BASE_URL}/${image}`}
                            className="js-lazy"
                            style={{
                                width: "100%",
                                height: "400px",
                                objectFit: "cover",
                                objectPosition: "top",
                                display: "block"
                            }}
                        />
                    </SwiperSlide>                                     
                    ))
                ) : (
                    <SwiperSlide>
                        <div className="flex items-center justify-center h-[450px] bg-gray-200 text-gray-500">
                        </div>
                    </SwiperSlide>
                )}
            </Swiper>
        </div>
    );
};

export default HeroRSL;
